exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn[data-v-159e6d48] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.disabled[data-v-159e6d48] {\n  opacity: 0.5;\n}\n.animate-spin[data-v-159e6d48] {\n  animation: spin-data-v-159e6d48 0.8s ease-in-out infinite;\n}\n@keyframes spin-data-v-159e6d48 {\nfrom {\n    transform: rotate(0deg);\n}\nto {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
